module.exports = __webpack_public_path__ + "static/media/yuandanmin.a0bb3bae.jpg";